<template>
  <div class="inputs">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1040px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :append-to-body="appendToBody"
      :destroy-on-close="destroyOnClose"
      ref="ecoDialog"
    >
      <el-container>
        <el-aside width="210px" class="left-aside">
          <el-card class="box-card org-find-card" shadow="never">
            <eco-tree
              :data="treeData"
              :default-expand-all="false"
              :highlight-current="true"
              :props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
              :node-key="nodeKey"
              :default-expanded-keys="defaultExpandedKeys"
              ref="tree"
              @node-click="handleNodeClick"
              accordion
            ></eco-tree>
          </el-card>
        </el-aside>
        <el-container>
          <el-main>
            <selector
              ref="selector"
              :data="data"
              :showSearch="false"
              :quickSearchProps="quickSearchProps"
              :selectSearchProps="selectSearchProps"
              :table-columns="tableColumns"
              :select-label="selectLabel"
              :isShowPagenation="false"
              :single="single"
              @reset="reset"
              @load="load"
              v-model="selectors"
            />
          </el-main>
        </el-container>
      </el-container>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleDialogSure"
          >确 定</el-button
        >
        <el-button size="small" @click="handleDialogCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import utils from "@/utils.js";
import Selector from "@/components/eipControl/Selector.vue";
import { setTimeout } from "timers";
import portal from "@/api/portal";

export default {
  name: "wx-dialog",
  props: {
    props: {
      type: Object,
      default() {
        return {};
      }
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: String,
    single: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tableColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selectLabel: {
      type: String,
      default: "name"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    quickSearchProps: {
      type: [String, Array],
      required: false,
      default: ""
    },
    nodeKey: {
      type: String,
      default: "id"
    },
    defaultExpandedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Selector
  },
  data() {
    return {
      dialogTitle: "微信同步对话框",
      inputName: null,
      selectors: [],
      selectSearchProps: [],
      dialogVisible: false
    };
  },
  methods: {
    // 同步value到当前所选数据中
    showDialog() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$refs.selector.onHide();
      done && done();
    },
    handleDialogSure() {
      this.dialogVisible = false;
      this.$refs.selector.onHide(true);
      this.$emit("onConfirm", this.selectors);
    },
    handleDialogCancel() {
      this.dialogVisible = false;
      this.$refs.selector.onHide();
    },
    handleRemove(item) {
      this.selectors.remove(item);
    },
    load(param, cb) {
      this.$emit("load", param, cb);
    },
    handleNodeClick(data) {
      this.$emit("nodeClick", data);
    },
    reset() {
      this.$emit("reset");
    }
  }
};
</script>
<style lang="stylus" scoped>
.inputs {
  display: block;
}

.el-select__tags {
  background: #fff;
  margin-left: 1px;
}

.el-select__tags_readonly {
  position: relative;
  top: 50%;
}

.el-input__inner[aria-invalid='true'] {
  border-color: #f56c6c;
}

>>> .el-dialog__header {
  background: #F8F8F8;
  padding: 10px 20px;
  line-height: 24px;
  border-bottom: 1px solid #eee;
  border-radius: 2px 2px 0 0;
}

>>> .el-dialog__title {
  font-size: 15px;
  color: #333;
}

>>> .el-dialog__headerbtn {
  top: 14px;
}

>>> .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}

>>> .el-main{
  padding-top: 0;
  padding-bottom: 0;
}
</style>
